// --------------- Start : Kategoriefilter einblenden above the fold ---------------

document.addEventListener('click', (event) => {
  const label = event.target.closest('.filter-form__label');
  if (!label) return;

  const parent = label.closest('.filter-form__item');

  document.querySelectorAll('.filter-form__item')
    .forEach(item => item !== parent && item.classList.remove('form-item-open'));

  parent.classList.toggle('form-item-open');
});

document.addEventListener('DOMContentLoaded', () => {

    const toggletarget = document.querySelector('.filter-b-toggle');
    const stickyToggle = document.querySelector('.filter-sticky-toggle');

    if (toggletarget || stickyToggle){
        const toggleObserver = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              stickyToggle.classList.remove('active_toggle');
            } else {
              stickyToggle.classList.add('active_toggle');
            }
          },
          {
            root: null,
            threshold: 0
          }
        );

      if (window.innerWidth <= 768) {
        toggleObserver.observe(toggletarget);
      }
    }

  document.addEventListener('change', (event) => {
    const filter_item = event.target.closest('.filter-chip__input');
    const price_range_min = event.target.closest('.filter-form--version-b .price-range__input-min');
    const price_range_max = event.target.closest('.filter-form--version-b .price-range__input-max');
    
    if(filter_item){
      const data_filter_value = filter_item.value;
      document.querySelector(`.tag__input[value="${data_filter_value}"]`).click(); 
    }

    if (price_range_min) {
      const data_value = price_range_min.value;
      const input = document.querySelector('#FilterDrawer .price-range__input-min');
      if (input) {
        input.value = data_value;
        console.log(input.value);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    if (price_range_max) {
      const data_value = price_range_max.value;
      const input = document.querySelector('#FilterDrawer .price-range__input-max');
      if (input) {
        input.value = data_value;
        console.log(input.value);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

  });

});
// --------------- End : Kategoriefilter einblenden above the fold ---------------

document.addEventListener('DOMContentLoaded', function() {
  
    function checkForElement() {
      
        const element = document.querySelector('div[data-testid="minimized-trustbadge-floating"]');
        
        if (element) {
         
            const grandparent = element.parentElement?.parentElement;
            
        
            if (grandparent) {
                grandparent.style.zIndex = '20';
            }
            
            clearInterval(intervalId);
        }
    }

    const intervalId = setInterval(checkForElement, 100);

    setTimeout(function() {
      clearInterval(intervalId);
    }, 120000);

    const scrollThreshold = parseInt(document.body.getAttribute('show_widget'), 10) || 0;
    const hiddenElement = document.querySelector('.wa__widget_container');

    if (hiddenElement) {
      window.addEventListener('scroll', function () {
        if (window.scrollY > scrollThreshold) {
          hiddenElement.style.display = 'block';
        } else {
          hiddenElement.style.display = 'none';
        }
      });
    }
    // window.addEventListener('scroll', function() {
    //   const scrollThreshold = parseInt(document.body.getAttribute('show_widget'));
    //   const hiddenElement = document.querySelector('.wa__widget_container');
    
    //     if (window.scrollY > scrollThreshold) {
    //         hiddenElement.style.display = 'block'; // or use hiddenElement.classList.add('visible') if you have a CSS class for it
    //     } else {
    //         hiddenElement.style.display = 'none'; // or use hiddenElement.classList.remove('visible') if you have a CSS class for it
    //     }
    // });
  
});

const reviewObserver = new MutationObserver(() => {
  const button = document.querySelector("#ReviewsWidget .R-Button.R-Button--md.R-Button--primary.u-marginBottom--none.u-marginTop--md");
  
  if (button) {
    button.textContent = "Schreibe eine Bewertung";
    reviewObserver.disconnect();
    clearTimeout(timeoutId);
  }
});

document.addEventListener("DOMContentLoaded", function() {
  const reviewsWidget = document.querySelector("#ReviewsWidget");
  if (reviewsWidget) {
    reviewObserver.observe(reviewsWidget, { childList: true, subtree: true });
  } else {
    reviewObserver.observe(document.body, { childList: true, subtree: true });
  }
});

const timeoutId = setTimeout(() => {
  reviewObserver.disconnect();
  console.log("Stopped observing - Review.io empty review element not found within the time limit.");
}, 5000);

// 27/01/26H  PDP: BuyBox strukturieren und optimieren - Schritt 2
document.addEventListener('DOMContentLoaded', function () {
  var div = document.querySelector(".product-section");
  div?.classList.add("product-section-var-b");
  var body = document.querySelector("body");
  body.classList.add("product-section-var-b");
  
  var meta = document.querySelector('.product-single__meta');
  if (!meta) return;

  // Create wrapper if not exists
  var wrapper = meta.querySelector('.review_with_sku');
  if (!wrapper) {
    wrapper = document.createElement('div');
    wrapper.className = 'review_with_sku';
    meta.prepend(wrapper);
  }

  function moveElements() {
    var review = document.querySelector('reviewsio-product-ratings');
    var sku = meta.querySelector('.product-single__sku');

    if (review && !wrapper.contains(review)) wrapper.appendChild(review);
    if (sku && !wrapper.contains(sku)) wrapper.appendChild(sku);
  }

  // Try immediately after DOM is ready
  moveElements();

  // Keep watching because Reviews.io loads later
  var observer_old = new MutationObserver(function () {
    moveElements();

    var review = document.querySelector('reviewsio-product-ratings');
    var sku = meta.querySelector('.product-single__sku');

    if (review && sku && wrapper.contains(review) && wrapper.contains(sku)) {
      observer_old.disconnect();
    }
  });


  observer_old.observe(document.body, { childList: true, subtree: true });
});

// ------------- A/B Test - Cart: Garantieverlängerung als Upsell -------------
document.addEventListener('change', async (e) => {

  const warranty_input = e.target.closest('.warranty_upsell_input');
  if (!warranty_input) return;

  const id = warranty_input.value;

  try {
    warranty_input.disabled = true;

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: id,
            quantity: 1
          }
        ]
      })
    });

    document.dispatchEvent(new CustomEvent("cart:build", {}));

  } catch (error) {
    warranty_input.disabled = false;
    warranty_input.checked = false;
    console.error('Error adding warranty:', error);
  }

});
// ------------- A/B Test - Cart: Garantieverlängerung als Upsell -------------
/* KI-Hinweis Lightbox: Badge nur beim ersten Bild – schlanker Observer (nur Lightbox) */
(function () {
  var bound = false;

  function sync(lb) {
    if (!lb) return;
    var open = lb.classList.contains('is-open');
    var counter = lb.querySelector('.pdp-lightbox__counter');
    var isFirst = counter && /^\s*1\s*\/\s*\d+/.test(counter.textContent.trim());
    lb.classList.toggle('ai-badge-first', open && isFirst);
  }

  function bind() {
    var lb = document.querySelector('.pdp-lightbox');
    if (!lb || bound) return;
    bound = true;
    var mo = new MutationObserver(function () {
      sync(lb);
    });

    mo.observe(lb, {
      attributes: true,
      attributeFilter: ['class'],
      subtree: true,
      childList: true,
      characterData: true
    });

    sync(lb);
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.product-media-grid, .pdp-lightbox')) {
      setTimeout(bind, 100);
      setTimeout(function () {
        sync(document.querySelector('.pdp-lightbox'));
      }, 160);
    }
  }, true);

  if (document.querySelector('.pdp-lightbox')) {
    bind();
  }
})();

/* KI-Hinweis Galerie: klickbarer Badge (mit i) + Info-Popup */
(function () {

  function init() {
    var wrap = document.querySelector('.product__photos:has(> .product-media-grid)');
    if (!wrap || wrap.querySelector('.ai-badge')) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ai-badge';
    btn.innerHTML =
      '<span>KI Hinweis</span>' +
      '<span class="ai-badge__i" aria-hidden="true">i</span>';

    wrap.appendChild(btn);

    var modal = document.createElement('div');
    modal.className = 'ai-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-hidden', 'true');

    modal.innerHTML =
      '<div class="ai-modal__box">' +
        '<div class="ai-modal__head">Hinweis zu den Produktbildern</div>' +
        '<button type="button" class="ai-modal__close" aria-label="Schliessen">\u00D7</button>' +
        '<p class="ai-modal__text">Einige Produktbilder wurden teilweise mit KI erstellt.<br><br><b>Aber keine Sorge:</b> Das dargestellte Produkt entspricht dem echten Artikel.</p>' +
      '</div>';

    document.body.appendChild(modal);

    function open() {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
    }

    function close() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
    }

    btn.addEventListener('click', open);

    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target.classList.contains('ai-modal__close')) {
        close();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        close();
      }
    });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }

  var tries = 0;
  var iv = setInterval(function () {
    tries++;
    init();

    if (document.querySelector('.ai-badge') || tries > 20) {
      clearInterval(iv);
    }
  }, 300);

})();
/* =========================================================
   Übersetzungen für KI-Hinweis und KI-Popup
   Grundlage: <html lang="de">, <html lang="fr"> oder
   <html lang="nl">
   ========================================================= */

(function () {
  var translations = {
    de: {
      badge: 'KI Hinweis',
      badgeAria: 'Hinweis zu den Produktbildern öffnen',
      heading: 'Hinweis zu den Produktbildern',
      close: 'Schließen',
      text:
        'Einige Produktbilder wurden teilweise mit KI erstellt.' +
        '<br><br>' +
        '<b>Aber keine Sorge:</b> Das dargestellte Produkt ' +
        'entspricht dem echten Artikel.'
    },

    fr: {
      badge: 'Info IA',
      badgeAria:
        'Ouvrir les informations sur les images du produit',
      heading: 'Informations sur les images du produit',
      close: 'Fermer',
      text:
        'Certaines images du produit ont été en partie créées ' +
        'à l’aide de l’IA.' +
        '<br><br>' +
        '<b>Mais rassurez-vous :</b> le produit présenté ' +
        'correspond à l’article réel.'
    },

    nl: {
      badge: 'AI-info',
      badgeAria:
        'Informatie over de productafbeeldingen openen',
      heading: 'Informatie over de productafbeeldingen',
      close: 'Sluiten',
      text:
        'Sommige productafbeeldingen zijn gedeeltelijk met ' +
        'AI gemaakt.' +
        '<br><br>' +
        '<b>Maar geen zorgen:</b> het afgebeelde product ' +
        'komt overeen met het echte artikel.'
    }
  };

  var updateScheduled = false;

  function getLanguage() {
    var language =
      document.documentElement.getAttribute('lang') || 'de';

    language = language.toLowerCase();

    if (language.indexOf('fr') === 0) {
      return 'fr';
    }

    if (language.indexOf('nl') === 0) {
      return 'nl';
    }

    return 'de';
  }

  function translateBadges(language, content) {
    var badges = document.querySelectorAll('.ai-badge');

    badges.forEach(function (badge) {
      if (badge.dataset.aiLanguage === language) {
        return;
      }

      badge.dataset.aiLanguage = language;

      var badgeText = badge.querySelector('span:first-child');

      if (badgeText) {
        badgeText.textContent = content.badge;
      }

      badge.setAttribute(
        'aria-label',
        content.badgeAria
      );
    });
  }

  function translateModals(language, content) {
    var modals = document.querySelectorAll('.ai-modal');

    modals.forEach(function (modal) {
      if (modal.dataset.aiLanguage === language) {
        return;
      }

      modal.dataset.aiLanguage = language;

      var heading = modal.querySelector('.ai-modal__head');
      var text = modal.querySelector('.ai-modal__text');
      var closeButton =
        modal.querySelector('.ai-modal__close');

      if (heading) {
        heading.textContent = content.heading;
      }

      if (text) {
        text.innerHTML = content.text;
      }

      if (closeButton) {
        closeButton.setAttribute(
          'aria-label',
          content.close
        );
      }
    });
  }

  function applyTranslations() {
    var language = getLanguage();
    var content =
      translations[language] || translations.de;

    translateBadges(language, content);
    translateModals(language, content);
  }

  function scheduleTranslation() {
    if (updateScheduled) {
      return;
    }

    updateScheduled = true;

    window.requestAnimationFrame(function () {
      updateScheduled = false;
      applyTranslations();
    });
  }

  /*
   * Sofort übersetzen, falls Badge und Popup bereits existieren.
   */
  applyTranslations();

  /*
   * Erfasst später erzeugte Badges und Popups sowie einen
   * Sprachwechsel ohne vollständiges Neuladen der Seite.
   */
  var translationObserver = new MutationObserver(
    scheduleTranslation
  );

  translationObserver.observe(
    document.documentElement,
    {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['lang']
    }
  );

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      applyTranslations
    );
  }
})();
